import styled from 'styled-components';
import { isMobile } from 'utils/platform';

export default styled.div`
  position: relative;
  left: ${({ index }) =>
    index % 2 === 0 ? (isMobile() ? '8%' : '15%') : '25%'};
  color: ${({ theme }) => theme.colors.primary.dark};
`;
